import { Country, CountryEnum, type CountryEnumType } from '@sr/types';

export type CompanyInfo = {
  country: Country;
  countryCode: CountryEnumType;
  isCS?: boolean;
};

const COMPANY_IDS_BY_ID: Record<number, CompanyInfo> = {
  [Country.SWEDEN]: { country: Country.SWEDEN, countryCode: CountryEnum.SE },
  900: { country: Country.SWEDEN, countryCode: CountryEnum.SE, isCS: true },

  [Country.NORWAY]: { country: Country.NORWAY, countryCode: CountryEnum.NO },
  901: { country: Country.NORWAY, countryCode: CountryEnum.NO, isCS: true },

  [Country.DENMARK]: { country: Country.DENMARK, countryCode: CountryEnum.DK },
  903: { country: Country.DENMARK, countryCode: CountryEnum.DK, isCS: true },

  [Country.FINLAND]: { country: Country.FINLAND, countryCode: CountryEnum.FI },
  101: { country: Country.FINLAND, countryCode: CountryEnum.FI },
  902: { country: Country.FINLAND, countryCode: CountryEnum.FI, isCS: true },

  [Country.POLAND]: { country: Country.POLAND, countryCode: CountryEnum.PL },
};

export const findCompanyIdEntry = (companyId: number | string): CompanyInfo | undefined =>
  COMPANY_IDS_BY_ID[Number(companyId)];

export const getCompanyIdEntry = (companyId: number | string): CompanyInfo => {
  const entry = findCompanyIdEntry(companyId);

  if (entry) {
    return entry;
  }

  throw new Error(`Unknown companyId '${companyId}'. Add it to COMPANY_IDS_BY_ID.`);
};

export const isKnownCompanyId = (companyId: number | string): boolean =>
  Object.prototype.hasOwnProperty.call(COMPANY_IDS_BY_ID, Number(companyId));

/** True when the id belongs to the Confidential (CS) source system. */
export const isCSCompanyId = (companyId: number | string): boolean =>
  findCompanyIdEntry(companyId)?.isCS === true;
